import { initialErrorState } from "views/common";

export function isValid(record) {
  const errors = initialErrorState();

  if (!record.companyId || !record.companyId.trim().length) {
    errors.messages.push("You must enter a valid company ID.");
    errors.entity.push("companyId");
  }
  if (record.showUser && !record.user) {
    errors.messages.push(
      "Select a user or switch back to Admin mode to continue."
    );
    errors.entity.push("user");
  }

  return errors;
}
